import { z } from "zod";

export const EreignisStatus = z.enum(["Offen", "InBearbeitung", "Geschlossen"]);
export type EreignisStatus = z.infer<typeof EreignisStatus>;

export const Ereignis = z.object({
  id: z.number().int().positive(),
  code: z.string(),
  reportedAt: z.number().int(),
  reporterUserId: z.number().int().nullable(),
  isEreignis: z.boolean(),
  isSecurityEvent: z.boolean(),
  isSecurityIncident: z.boolean(),
  isDataProtectionIncident: z.boolean(),
  isNonconformity: z.boolean(),
  description: z.string(),
  affectedAreas: z.string().nullable(),
  affectedInformation: z.string().nullable(),
  evidenceNotes: z.string().nullable(),
  comment: z.string().nullable(),
  status: EreignisStatus,
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
});
export type Ereignis = z.infer<typeof Ereignis>;

export const EreignisCreate = z.object({
  code: z.string().min(1).max(80).optional(),
  reportedAt: z.number().int().positive(),
  reporterUserId: z.number().int().positive().nullable().optional(),
  isEreignis: z.boolean().optional(),
  isSecurityEvent: z.boolean().optional(),
  isSecurityIncident: z.boolean().optional(),
  isDataProtectionIncident: z.boolean().optional(),
  isNonconformity: z.boolean().optional(),
  description: z.string().min(1).max(5000),
  affectedAreas: z.string().max(5000).nullable().optional(),
  affectedInformation: z.string().max(5000).nullable().optional(),
  evidenceNotes: z.string().max(5000).nullable().optional(),
  comment: z.string().max(5000).nullable().optional(),
  status: EreignisStatus.optional(),
});
export type EreignisCreate = z.infer<typeof EreignisCreate>;

export const EreignisUpdate = EreignisCreate.partial();
export type EreignisUpdate = z.infer<typeof EreignisUpdate>;
